export default __webpack_public_path__ + "static/button-label-dont-925aca0eebaadd0236c30eca429beb02.png";